import { Select } from "antd";

export interface IMultipleSelectFilterOption {
  label: string;
  value: string;
}

export interface IMultipleSelectFilterProperties {
  placeholder?: string;
  options: IMultipleSelectFilterOption[];
  onChange: (values: { value: string; label: string }[]) => void;
  value: string[];
  width?: number;
}

export const MultipleSelectFilter = (properties: IMultipleSelectFilterProperties) => {
  return (
    <Select
      style={{ minWidth: properties.width || "130px" }}
      mode={"multiple"}
      maxTagCount={1}
      value={properties.value}
      popupMatchSelectWidth={false}
      placeholder={properties.placeholder}
      onChange={(_, option) => {
        option ? properties.onChange(option as { value: string; label: string }[]) : properties.onChange([]);
      }}
      filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input?.toLowerCase())}
      options={properties.options || []}
    />
  );
};
